import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Navigation
      home: 'Home',
      about: 'About Us',
      industries: 'Industries',
      materials: 'Materials',
      process: 'Process',
      gallery: 'Gallery',
      contact: 'Contact',
      getQuote: 'Get Quote',
      
      // Hero
      heroTagline: 'WHERE STONE BECOMES ART',
      heroSubtitle: 'Leading marble and natural stone specialist in UAE',
      exploreMaterials: 'Explore Materials',
      requestQuote: 'Request Quote',
      
      // About
      aboutTitle: 'About Dar Al Safaa',
      aboutDescription: 'Dar Al Safaa Marbles Industries LLC is a leading marble and natural stone specialist based in UAE. With years of expertise in the field, we are dedicated to transforming natural stone into masterpieces of design, craftsmanship, and functionality.',
      ourVision: 'Our Vision',
      visionText: 'To lead the industry through continuous innovation, adopting cutting-edge technology, and nurturing a skilled workforce dedicated to precision and artistry.',
      whyChooseUs: 'Why Choose Us',
      qualityAssurance: 'Quality Assurance',
      qualityText: 'Premium-grade marble and stone from trusted global quarries',
      advancedTech: 'Advanced Technology',
      techText: 'Cutting-edge CNC and waterjet machines for precision work',
      skilledCraft: 'Skilled Craftsmanship',
      craftText: 'Experienced artisans and technicians deliver flawless execution',
      clientCentric: 'Client-Centric Approach',
      clientText: 'Working closely with architects, designers, and contractors',
      timelyDelivery: 'Timely Delivery',
      deliveryText: 'Efficient processes and project management',
      
      // Industries
      industriesTitle: 'Industries We Serve',
      industriesSubtitle: 'Delivering excellence across diverse sectors',
      residential: 'Residential Villas',
      hotels: 'Hotels & Resorts',
      corporate: 'Corporate Offices',
      malls: 'Malls & Retail',
      government: 'Government Projects',
      religious: 'Religious Buildings',
      hospitality: 'Hospitality & Healthcare',
      
      // Materials
      materialsTitle: 'Materials & Products',
      materialsSubtitle: 'Premium marble and natural stone solutions',
      flooring: 'Marble Flooring',
      flooringDesc: 'Precision-cut for residential and commercial spaces',
      wallCladding: 'Wall Cladding',
      claddingDesc: 'Interior and exterior, variety of natural stones',
      stairs: 'Stairs & Skirting',
      stairsDesc: 'Custom-designed with seamless finishing',
      countertops: 'Countertops & Vanity',
      countertopsDesc: 'Luxurious marble for kitchens and bathrooms',
      waterjet: 'Waterjet Designs',
      waterjetDesc: 'Intricate patterns, medallions, and artistic inlays',
      fireplaces: 'Fireplaces',
      fireplacesDesc: 'Elegant stone fireplaces',
      pools: 'Swimming Pools',
      poolsDesc: 'Marble stonework for surrounds and decks',
      custom: 'Custom Fabrication',
      customDesc: 'Bespoke solutions tailored to your vision',
      
      // Process
      processTitle: 'Our Process',
      processSubtitle: 'From quarry to installation',
      step1: 'Sourcing',
      step1Desc: 'Premium marble and stone from trusted global quarries',
      step2: 'Cutting & Fabrication',
      step2Desc: 'State-of-the-art CNC and waterjet machines',
      step3: 'Finishing',
      step3Desc: 'Expert polishing and quality control',
      step4: 'Installation',
      step4Desc: 'Professional installation by skilled technicians',
      
      // Gallery
      galleryTitle: 'Our Portfolio',
      gallerySubtitle: 'Explore our completed projects',
      viewProject: 'View Project',
      
      // Contact
      contactTitle: 'Get In Touch',
      contactSubtitle: 'We\'d love to hear from you',
      yourName: 'Your Name',
      yourEmail: 'Your Email',
      yourPhone: 'Your Phone',
      yourMessage: 'Your Message',
      sendMessage: 'Send Message',
      sending: 'Sending...',
      
      // Quote Form
      quoteTitle: 'Request a Quote',
      projectType: 'Project Type',
      materialsNeeded: 'Materials Needed',
      projectDescription: 'Project Description',
      submitQuote: 'Submit Quote Request',
      
      // Footer
      location: 'Location',
      locationText: 'Al Sajaa Industrial Area, Sharjah, UAE',
      emailLabel: 'Email',
      phoneLabel: 'Phone',
      quickLinks: 'Quick Links',
      followUs: 'Follow Us',
      allRightsReserved: 'All rights reserved',
      
      // Messages
      thankYou: 'Thank you!',
      messageSent: 'Your message has been sent successfully.',
      quoteSent: 'Your quote request has been submitted.',
      error: 'Error',
      tryAgain: 'Please try again later.',
    }
  },
  ar: {
    translation: {
      // Navigation
      home: 'الرئيسية',
      about: 'من نحن',
      industries: 'القطاعات',
      materials: 'المواد',
      process: 'العملية',
      gallery: 'المعرض',
      contact: 'اتصل بنا',
      getQuote: 'احصل على عرض',
      
      // Hero
      heroTagline: 'حيث يصبح الحجر فنًا',
      heroSubtitle: 'الشركة الرائدة في مجال الرخام والحجر الطبيعي في الإمارات',
      exploreMaterials: 'استكشف المواد',
      requestQuote: 'اطلب عرض أسعار',
      
      // About
      aboutTitle: 'عن دار الصفاء',
      aboutDescription: 'دار الصفاء لصناعات الرخام ذ.م.م هي شركة رائدة متخصصة في الرخام والحجر الطبيعي في الإمارات. مع سنوات من الخبرة في هذا المجال، نحن ملتزمون بتحويل الحجر الطبيعي إلى تحف فنية من التصميم والحرفية والوظيفة.',
      ourVision: 'رؤيتنا',
      visionText: 'قيادة الصناعة من خلال الابتكار المستمر، واعتماد التكنولوجيا المتطورة، ورعاية قوة عاملة ماهرة مكرسة للدقة والفن.',
      whyChooseUs: 'لماذا تختارنا',
      qualityAssurance: 'ضمان الجودة',
      qualityText: 'رخام وحجر من الدرجة الممتازة من محاجر عالمية موثوقة',
      advancedTech: 'تكنولوجيا متقدمة',
      techText: 'أحدث آلات CNC والقطع بالماء للعمل الدقيق',
      skilledCraft: 'حرفية ماهرة',
      craftText: 'حرفيون وفنيون ذوو خبرة يقدمون تنفيذًا لا تشوبه شائبة',
      clientCentric: 'نهج يركز على العملاء',
      clientText: 'العمل بشكل وثيق مع المهندسين المعماريين والمصممين والمقاولين',
      timelyDelivery: 'التسليم في الوقت المحدد',
      deliveryText: 'عمليات وإدارة مشاريع فعالة',
      
      // Industries
      industriesTitle: 'القطاعات التي نخدمها',
      industriesSubtitle: 'تقديم التميز عبر قطاعات متنوعة',
      residential: 'الفلل السكنية',
      hotels: 'الفنادق والمنتجعات',
      corporate: 'المكاتب الشركات',
      malls: 'المراكز التجارية',
      government: 'المشاريع الحكومية',
      religious: 'المباني الدينية',
      hospitality: 'الضيافة والرعاية الصحية',
      
      // Materials
      materialsTitle: 'المواد والمنتجات',
      materialsSubtitle: 'حلول رخام وحجر طبيعي متميزة',
      flooring: 'أرضيات الرخام',
      flooringDesc: 'مقطوعة بدقة للمساحات السكنية والتجارية',
      wallCladding: 'كسوة الجدران',
      claddingDesc: 'داخلي وخارجي، مجموعة متنوعة من الأحجار الطبيعية',
      stairs: 'السلالم والأرضيات',
      stairsDesc: 'مصممة خصيصًا بتشطيب سلس',
      countertops: 'أسطح المطابخ والحمامات',
      countertopsDesc: 'رخام فاخر للمطابخ والحمامات',
      waterjet: 'تصاميم القطع بالماء',
      waterjetDesc: 'أنماط معقدة وميداليات وأعمال فنية',
      fireplaces: 'المدافئ',
      fireplacesDesc: 'مدافئ حجرية أنيقة',
      pools: 'حمامات السباحة',
      poolsDesc: 'أعمال حجرية رخامية للمحيط والأسطح',
      custom: 'التصنيع المخصص',
      customDesc: 'حلول مخصصة مصممة وفقًا لرؤيتك',
      
      // Process
      processTitle: 'عمليتنا',
      processSubtitle: 'من المحجر إلى التركيب',
      step1: 'التوريد',
      step1Desc: 'رخام وحجر ممتاز من محاجر عالمية موثوقة',
      step2: 'القطع والتصنيع',
      step2Desc: 'أحدث آلات CNC والقطع بالماء',
      step3: 'التشطيب',
      step3Desc: 'صقل احترافي ومراقبة الجودة',
      step4: 'التركيب',
      step4Desc: 'تركيب احترافي بواسطة فنيين ماهرين',
      
      // Gallery
      galleryTitle: 'معرض أعمالنا',
      gallerySubtitle: 'استكشف مشاريعنا المنجزة',
      viewProject: 'عرض المشروع',
      
      // Contact
      contactTitle: 'تواصل معنا',
      contactSubtitle: 'نود أن نسمع منك',
      yourName: 'اسمك',
      yourEmail: 'بريدك الإلكتروني',
      yourPhone: 'هاتفك',
      yourMessage: 'رسالتك',
      sendMessage: 'إرسال الرسالة',
      sending: 'جارٍ الإرسال...',
      
      // Quote Form
      quoteTitle: 'اطلب عرض أسعار',
      projectType: 'نوع المشروع',
      materialsNeeded: 'المواد المطلوبة',
      projectDescription: 'وصف المشروع',
      submitQuote: 'إرسال طلب العرض',
      
      // Footer
      location: 'الموقع',
      locationText: 'المنطقة الصناعية السجعة، الشارقة، الإمارات',
      emailLabel: 'البريد الإلكتروني',
      phoneLabel: 'الهاتف',
      quickLinks: 'روابط سريعة',
      followUs: 'تابعنا',
      allRightsReserved: 'جميع الحقوق محفوظة',
      
      // Messages
      thankYou: 'شكرًا لك!',
      messageSent: 'تم إرسال رسالتك بنجاح.',
      quoteSent: 'تم إرسال طلب العرض الخاص بك.',
      error: 'خطأ',
      tryAgain: 'يرجى المحاولة مرة أخرى لاحقًا.',
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
